import axios from 'axios';
import dayjs from 'dayjs';
import { store } from 'store';

import { set as setLocal } from '~libs/localstorage';

import { removeAuthenticated, setForceRedirect, setSessionToken } from '~main/reducers/login';

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (request) => {
      const token = store.getState().main.login.sessionToken;
      if (token) {
        request.headers['x-session-token'] = token;
      }
      request.headers['UTC-Offset'] = dayjs().format('ZZ');
      return request;
    },
    (error) => error,
  );

  axios.interceptors.response.use(
    (response) => {
      const token = response.headers['x-session-token'];
      if (token) {
        store.dispatch(setSessionToken(token));
        setLocal('x-session-token', token);
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        const { data } = error.response;
        if (data.reason === 'company-disabled') store.dispatch(setForceRedirect());
        store.dispatch(removeAuthenticated());
      }
      return Promise.reject(error);
    },
  );
};
